import { Chip, Icon } from "@firecms/ui";

import { type PromoCodeStatusTagProps } from "./PromoCodeStatusTag.types";

const colorSchemeByType = {
  success: "greenLighter",
  danger: "redLighter",
  info: "blueLighter",
} as const;

const PromoCodeStatusTag: React.FC<PromoCodeStatusTagProps> = ({ type, text, iconKey }) => {
  return (
    <Chip size="small" colorScheme={colorSchemeByType[type]} icon={<Icon iconKey={iconKey} size="small" />}>
      {text}
    </Chip>
  );
};

export default PromoCodeStatusTag;
